import { IsString, IsOptional, IsEnum } from 'class-validator';
import { OnboardingProgress } from './onboarding.types';

/**
 * Programming experience levels for user context
 */
export enum ProgrammingExperience {
  NONE = 'none',
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced'
}

/**
 * User Context for AI Agents
 * Stored in users.context (JSONB)
 */
export interface UserContext {
  /** Job role/title (e.g., "IT Admin Manager", "Data Analyst") */
  role?: string;

  /** Department (e.g., "Plant Operations", "Marketing") */
  department?: string;

  /** Programming experience level */
  programmingExperience?: ProgrammingExperience;

  /** How the user intends to use OptiDev */
  usageIntent?: string;

  /** Onboarding checklist progress */
  onboarding?: OnboardingProgress;
}

/**
 * DTO for updating user context
 */
export class UserContextDto {
  @IsString()
  @IsOptional()
  role?: string;

  @IsString()
  @IsOptional()
  department?: string;

  @IsEnum(ProgrammingExperience)
  @IsOptional()
  programmingExperience?: ProgrammingExperience;

  @IsString()
  @IsOptional()
  usageIntent?: string;
}
